<div class="bg-cp-primary-8 py-4 flex flex-col justify-center items-center rounded h-full">
  @if (isBoolean()) {
    @if (isChecked()) {
      @if (isFilled()) {
        <mat-icon svgIcon="cp-check-filled" />
      } @else {
        <mat-icon svgIcon="cp-check-outline" />
      }
    } @else {
      @if (isFilled()) {
        <mat-icon svgIcon="cp-close-filled" />
      } @else {
        <mat-icon svgIcon="cp-close-outline" />
      }
    }
  } @else if (numberValue() !== null) {
    <strong>{{ numberValue() | specialNumericLabel }}{{ einheitSuffix() }}</strong>
  } @else if (stringValue()) {
    <strong>{{ stringValue() }}</strong>
  } @else if (listValues(); as entries) {
    <ul class="text-center">
      @for (entry of entries; track entry.label) {
        <li><strong>{{ entry.label }}</strong></li>
      }
    </ul>
  }

  @if (showBedingungstexte()) {
    <div class="mt-2 text-xs space-y-1 text-left px-2">
      @if (!item().bedingungstexte.length) {
        <p>--</p>
      }
      @for (text of item().bedingungstexte; track text.text) {
        <button
          type="button"
          class="w-full text-left cursor-pointer"
          [class.line-clamp-6]="!expanded()"
          (click)="expanded.set(!expanded())"
        >
          <p>{{ text.text }}</p>
        </button>
      }
    </div>
  }
</div>
